import { createApp } from "vue";
import { vfmPlugin } from "vue-final-modal";
import App from "./App.vue";
import axiosPlugin from "./axiosPlugin.mjs";
import router from "./router";
import store from "./store";
import translates from "./utilities/translates";
import { createI18n } from "vue-i18n";
import ToastPlugin from "vue-toast-notification";
import { initAnalytics } from "./utilities/analytics";
import "vue-toast-notification/dist/theme-bootstrap.css";
import "flatpickr/dist/flatpickr.min.css";
// Icone: pacchetto npm self-hosted, non un kit remoto. Le icone restano
// disponibili offline e non dipendono da servizi esterni (CSP-friendly).
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";

const app = createApp(App);
// Create a new instance of VueI18n
const i18n = createI18n({
  locale: "it",
  fallbackLocale: "en",
  messages: translates,
});
app.use(axiosPlugin);
app.use(store);
// [sc-48497 / task 48527] `isReadOnly` disponibile ovunque senza importarlo in
// ogni schermata: la sola lettura riguarda l'azienda intera, non un componente.
// Il rifiuto vero resta al server e all'interceptor; questo serve a spegnere i
// pulsanti, cioe' a non far cliccare quello che non si puo' fare.
app.mixin({
  computed: {
    isReadOnly() {
      return store.getters["company/readOnly"];
    },
  },
});

app.use(ToastPlugin, {
  position: "bottom-right", // forza il posizionamento
  duration: 3500, // ms
  dismissible: true, // mostra la X
  pauseOnHover: true,
  queue: false,
});
app.use(i18n);
app.use(
  vfmPlugin({
    key: "$vfm",
    componentName: "VueFinalModal",
    dynamicContainerName: "ModalsContainer",
  })
);
// Analytics (Umami): si attiva solo se configurato, non blocca mai l'avvio.
initAnalytics(router);

// Marchio dell'azienda: la richiesta parte subito ma non blocca l'avvio.
// Se l'API non risponde l'applicazione si apre con i valori predefiniti.
store.dispatch("fetchCompanyBranding");

app.use(router).mount("#app");
// Rendi axios disponibile globalmente
// app.config.globalProperties.$axios = axios;
